import React from 'react'
import { connect } from 'react-redux'

import { Link} from "react-router-dom"
import './openGames.css'
import axios from 'axios'
import {userList} from '../../redux/chatuser.redux.js'
import {authenticationFn} from '../../redux/chatuser.redux.js'
import {authenMsg} from '../../redux/chatuser.redux.js'

@connect(
  state=>state.chatuser,
  {userList,authenticationFn,authenMsg}
)

class OpenGames extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <div className="open-games-box">
                <p className="games-num">目前回归特权已开放游戏共 <span>{this.props.gameList && this.props.gameList.length}</span> 款</p>
                <div className="open-games-list">
                    <p className="open-games-title">
                        <span className="i"></span>
                        <span>开放游戏</span>
                        <span className="i"></span>
                    </p>
                    <ul className="games-list">
                        {
                            this.props.gameList && this.props.gameList.map((item, i) => {
                                return (
                                    <li key={i}>
                                        <span className="icon">常用</span>
                                        <img src={item.newgamepage_img} />
                                        <div className="game-name">
                                            <p><strong>{item.gamename}</strong></p>
                                            <p onClick={() => this.props.handleLink(item)}>查看回归特权</p>
                                        </div>
                                    </li>
                                )
                            })
                        }
                        
                    </ul>
                    <div className="all-games-btn">查看全部</div>
                </div>
            </div>
        )
    }
}

export default OpenGames;


// WEBPACK FOOTER //
// ./src/component/open-games/openGames.js